<template>
  <div class="box">
    <img :src="$cdnPath.img + 'Activity/2051/bg2.png'"/>
    <div class="box_btn" @click="showRst('vip')"></div>
  </div>
</template>

<script>
  import { fetch,post } from '@/api/appRequest.js';
  import API from '@/api/app.conf.js';
  export default {
    name: "index",
    data() {
      return {
        fooId:11010, activityId:128,
        rst:0
      };
    },
    methods:{
      showRst(a) {
        this.$dialog.loading.open('正在领取...');
        post(API.U('receive_reward'), {activity_id:128}).then(res => {
          this.$dialog.loading.close();
          if (res.status_code == 200) {
            this.$dialog.alert({mes:'恭喜成功领取1天VIP，所有图解免费看哦！'});
            this.$SPM(this.fooId,this.activityId, `.${a}.1`);
          } else if (res.status_code == 805) {
            this.$dialog.notify({mes:'VIP只限领取1次！'});
            this.$SPM(this.fooId,this.activityId, `.${a}.2`);
          } else if (res.status_code == 403) {
            this.$dialog.alert({
              mes: "请先登录", callback: () => {
                this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 0)
              }
            });
          } else {
            this.$dialog.alert({mes:'code:' + res.status_code + '错误' + res.message});
            this.$SPM(this.fooId,this.activityId, `.${a}.0`);
          }
        }).catch(ex=>{
          this.$dialog.loading.close();
        });
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
.box {
  position: relative;
  &_btn {
    position:absolute; top:34%;left:60%; width:29%; height:50%;
  }
  img {
    width:100%;height:auto;
  }
}
</style>